<section class="row details-content no-padding no-margin-horizontal margin-top mt40 mobile-margin vehicle-policy-details"
  [ngClass]="{'ma-car-details-sec': !isAcmic, 'mh8': isAcmic}">
  <app-home-header    [policy]="policy" class="w-100" *ngIf="!isAcmic"></app-home-header>
  <div class="col-sm-12 col-md col1"  [ngClass]="{'details-all-width-left':isAcmic}">
    <div class="row policy-holders row-section" [ngClass]="{'no-margin-horizontal margin-bottom mb-3': !isAcmic, 'margin-bottom mb32': isAcmic}">
      <div class="col" [ngClass]="{'no-padding-horizontal': !isAcmic}">
        <h2 class="vehicle-sub title margin-bottom mb16" [ngClass]="{'details-car-header-ma': !isAcmic, 'details-car-header-acmic':isAcmic}" >         
              {{"POLICY_HOLDER_ONE_WORD" | translate }}{{ policy.insured.length > 1? "s": "" }}          
        </h2>
        <div class="policy-holder margin-bottom mb8 row"
          *ngFor="let holder of policy.insured | sort: 'isPrimaryInsured'" [ngClass]="{'no-margin-horizontal gap-8 policy-holder-subcontainer': !isAcmic}">
          <div class="policy-holder-info" [ngClass]="{'no-padding-horizontal car-holder-name': !isAcmic}">
            <h3 class="title vehicle-name veh-color" [ngClass]="{'fw-500': !isAcmic}">
                <!-- <img src="./assets/img/images/icon-user.svg" alt="user icon" /> -->
                 {{ holder["Insured Name"] | titlecase }}
            </h3>
          </div>
          <div class="col" *ngIf="holder.isPrimaryInsured && policy?.company.companyName==='MA'" [ngClass]="{'no-padding-horizontal car-holder-type-container': !isAcmic}">
            <span class="fs-16 veh-sub-color" [ngClass]="{'car-holder-type': !isAcmic, 'fs-14':isAcmic}">{{ "PRIMARY" | translate }}</span>
          </div>
          <div class="col" *ngIf="!holder.isPrimaryInsured && policy?.company.companyName==='MA'" [ngClass]="{'no-padding-horizontal car-holder-type-container': !isAcmic}">
            <span class="fs-16 veh-sub-color" [ngClass]="{'car-holder-type': !isAcmic, 'fs-14':isAcmic}">{{ "SECONDARY" | translate }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row vehicles row-section" [ngClass]="{'no-margin-horizontal margin-bottom mb-4': !isAcmic, 'margin-bottom mb32': isAcmic}">
      <div class="col" [ngClass]="{'no-padding-horizontal': !isAcmic}">
        <h2 class="vehicle-sub title margin-bottom mb16 veh-policy-details" [ngClass]="{'details-car-header-ma': !isAcmic, 'details-car-header-acmic':isAcmic}">            
          {{ "VEHICLES" | translate }}
        </h2>        
        <p class="section-description" *ngIf="!isAcmic && policy?.policyStatus !== 'ACTIVE'">
          {{ "ODOMETER_UPDATE_ACTIVE_ONLY" | translate }}.
        </p>
        <div>
            <div *ngFor="let vehicle of policy?.vehicle | sort: 'vehicleNumber' : 'asc';
                        index as i;
                        last as last;
                        first as first" [ngClass] = "{ 'vehicle-detail': !isAcmic }">
            <div id="id{{ i }}" class="margin-bottom mb8 vehicle-detail" [ngClass]="{ 'vehicle-top': i !== 0 && !isAcmic, 'margin-top mt24': i !== 0 && isAcmic }"
              *ngIf="vehicle?.vehicleIdentificationNumber?.Id !== ''">
              <h3 class="title vehicle-name veh-color" [ngClass]="{'veh-acmic': isAcmic, 'veh-ma': !isAcmic}">
                {{ vehicle?.vehicle | lowercase }}
              </h3>
              <div  class="title vehicle-name mileage" [ngClass]="{'w-100-mobile': isAcmic}">
                <div class="vehicle-info no-padding-horizontal" *ngIf="vehicle?.vehicleIdentificationNumber?.Id" [ngClass]="{'margin-bottom mb-3 gap-8 vehicle-info-ma-mobile': !isAcmic && vehicle?.vehicleIdentificationNumber?.Id}">
                    <div class="info-title" [ngClass]="{'vehicle-info-ma-left':!isAcmic, 'col-656565-imp':isAcmic}">{{ "VIN" | translate }}</div>
                    <div class="info-val" [ngClass]="{'info-val-ma dm-sans-medium': !isAcmic, 'col-363636-imp':isAcmic}">{{ vehicle?.vehicleIdentificationNumber?.Id }}</div>
                </div>
                <div class="vehicle-info no-padding-horizontal" *ngIf="!isAcmic && vehicle?.licensePlate" [ngClass]="{'margin-bottom mb-3 gap-8 vehicle-info-ma-mobile': !isAcmic && vehicle?.licensePlate}">
                    <div class="info-title" [ngClass]="{'vehicle-info-ma-left':!isAcmic, 'col-656565-imp':isAcmic}">{{ "PLATE" | translate }}</div>
                    <div class="info-val" [ngClass]="{'info-val-ma dm-sans-medium': !isAcmic, 'col-363636-imp':isAcmic}">{{ vehicle?.licensePlateState }} - {{ vehicle?.licensePlate }} </div>
                </div>
                <div class="vehicle-info no-padding-horizontal" *ngIf="vehicle?.primaryDrivers?.length" [ngClass]="{'margin-bottom mb-3 gap-8 vehicle-info-ma-mobile': !isAcmic && vehicle?.primaryDrivers?.length}">
                    <div class="info-title" [ngClass]="{'vehicle-info-ma-left':!isAcmic, 'col-656565-imp':isAcmic}">{{ "PRIMARY_DRIVER" | translate }}</div>
                    <div class="info-val" [ngClass]="{'info-val-ma dm-sans-medium': !isAcmic, 'col-363636-imp':isAcmic}">{{ vehicle?.primaryDrivers[0] | titlecase}} </div>
                </div>            
                <div class="vehicle-info no-padding-horizontal" *ngIf="vehicle?.occasionalDrivers?.length" [ngClass]="{'margin-bottom mb-3 gap-8 vehicle-info-ma-mobile': !isAcmic && vehicle?.occasionalDrivers?.length}">
                    <div class="info-title" [ngClass]="{'vehicle-info-ma-left':!isAcmic, 'col-656565-imp':isAcmic}">{{ "OTHER_DRIVER" | translate }} </div>
                    <div class="info-val other-drivers" [ngClass]="{'info-val-ma dm-sans-medium': !isAcmic}">
                      <ng-container *ngFor="let occasionalDriver of vehicle.occasionalDrivers">
                        <div class="other-drivers" [ngClass]="{'col-363636-imp':isAcmic}">{{ occasionalDriver | titlecase}}</div> 
                      </ng-container> </div>
                </div> 
                <div class="vehicle-info no-padding-horizontal" *ngIf="!isAcmic && showCompany==='ma'" [ngClass]="{'margin-bottom mb-3 gap-8 vehicle-info-ma-mobile': !isAcmic && showCompany==='ma'}">
                    <div class="info-title" [ngClass]="{'vehicle-info-ma-left':!isAcmic, 'col-656565-imp':isAcmic}">{{ "CURRENT_MILEAGE" | translate }}</div>
                    <div class="info-val" [ngClass]="{'info-val-ma dm-sans-medium': !isAcmic, 'col-363636-imp':isAcmic}">{{
                        vehicle?.odometerReading !== 0
                          ? vehicle?.odometerReading.toLocaleString()
                          : "Not available"
                        }}
                        <span class="tool-tip-align">
                          <mapfre-tooltip additionalClasses="tool-tip-w" 
                          [tooltipCopy]="'ODOMETER_UPDATE_ONE'" 
                          [placementLocation]="'right'"
                          [autoCloseProp] = "'false'"
                          [trigger]="'manual'"
                          >
                          <!-- <img src="assets/img/images/icon-info.svg" alt="info icon" /> -->
                          </mapfre-tooltip>
                        </span>
                      </div>
                </div> 
                
                <div class="vehicle-info id-card-actions no-padding-horizontal id-cards-acmic-actions" *ngIf="isAcmic && policy?.policyStatus === 'ACTIVE' && vehicle?.vehicleType !== 'utility_trailer'">
                  <div class="info-title" [ngClass]="{'grey-color':!isAcmic, 'col-656565-imp':isAcmic}">{{ "ID Card:" | translate }}</div>
                  <div class="info-val info-val-btns-acmic">
                    <mapfre-button          
                      [additionalClasses]="'view-id-card'"
                      (click)="getIdCardDocument(vehicle, 'view')"> {{"View" | translate}}
                    </mapfre-button>
                    <mapfre-button                      
                      [additionalClasses]="'download-btn'"
                      (click)="getIdCardDocument(vehicle, 'download')"> {{ "DOWNLOAD" | translate}}
                    </mapfre-button>
                  </div>
              </div> 
               
              </div>
              <div class="help-block error-block" *ngIf="checkIfIndexIsTheSame(errorMessage[i], i)">
                {{ errorMessage[i] | translate }}
              </div>
            </div>
            <ng-container *ngIf="
                vehicle?.vehicleIdentificationNumber?.Id === '' &&
                policy?.policyType !== 'AUTO'
              ">
              <h3 class="title vehicle-name">
                {{ vehicle?.vehicle }}
              </h3>
              <div class="row input-control">
                <div class="col input-field mapfre">
                  <div class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
                    {{ "THIS_VEHICLE_IS_NOT_ELIGIBLE" | translate }}
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="
                !allNotElibile &&
                vehicle?.vehicleIdentificationNumber?.Id !== '' &&
                policy?.policyStatus === 'ACTIVE' && !isAcmic && showCompany==='ma'">
                <div class="vehicle-info">
              <mapfre-button [ngClass]="{ custom_loader: loader }"
                [additionalClasses]="'btn mapfre ghost tertiary small odometer'" (click)="
                  onSubmit(
                    vehicle?.vehicleIdentificationNumber?.Id,
                    vehicle?.odometerReading,
                    vehicle?.vehicle,
                    i
                  )
                " [translateValue]="'REQUEST_UPDATE_MILEAGE' | translate">{{ "REQUEST_UPDATE_MILEAGE" | translate }}</mapfre-button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="coverage-footer" [ngClass]="{'margin-bottom mb32': isAcmic}">
        <div class="looking-more"
        [ngClass]="{'dm-sans-medium padding-bottom pb-2': !isAcmic, 'col-363636-imp': isAcmic}">{{ "LOOKING_MORE" | translate }}</div>
        <div class="c-links" [ngClass]="{'c-links-ma': !isAcmic}">
          <span  [ngClass]="{'looking-more-left':!isAcmic, 'col-656565-imp': isAcmic}">{{"POLICY_CHANGES" | translate }}</span>
          <ng-container *ngIf="isAcmic; else otherStateLogo">
            <a routerLink="/contact"   class="see-dec" [ngClass]="{'fs-14 fw-500':isAcmic}">{{ "Contact your agent" | translate }}</a>
        </ng-container>
        <ng-template #otherStateLogo>
          <a routerLink="/contact"   class="see-dec dm-sans-medium fs-16" [ngClass]="{'fs-14 fw-500':isAcmic}">{{ "Contact your agent" | translate }}</a>
        </ng-template>
        </div>
         <div class="c-links" *ngIf="!(showCompany === 'acic' || showCompany === 'tw')" [ngClass]="{'c-links-ma': !isAcmic}">
            <span

            [ngClass]="{'looking-more-left':!isAcmic, 'col-656565-imp': isAcmic}">{{"FULL_POLICY_INFO" | translate }}</span>
            <a routerLink="/my-insurance/{{
              policy?.policynumber?.policyNumber
            }}/documents"  [queryParams]="{filter: 'pol'}" class="see-dec fw-500" [ngClass]="{'fs-14':isAcmic, 'fs-16':!isAcmic}">{{ "POLICY_DOCUMENTS" | translate }}</a>
        </div>
         <div class="c-links" *ngIf="showCompany === 'acic' || showCompany === 'tw'" [ngClass]="{'c-links-ma': !isAcmic}">
          <span [ngClass]="{'looking-more-left':!isAcmic, 'col-526570': isAcmic}">{{"FULL_POLICY_INFO" | translate }}</span>
          <a routerLink="/my-insurance/{{
            policy?.policynumber?.policyNumber
          }}/documents" class="see-dec dm-sans-medium fs-16" [ngClass]="{'fs-14 fw-500':isAcmic}">{{ "POLICY_DOCUMENTS" | translate }}</a>
      </div>
    </div>
  </div>  
  <div class="col-sm-12 col-md col2 detials-sidebar"  [ngClass]="{'details-all-width-right details-sidebar-acmic vertical-line-color':isAcmic, 'no-padding-top': !isAcmic}">
    <app-details-sidebar [policy]="policy" (showToast)="showToast.emit($event)"></app-details-sidebar>
  </div>
</section>